import { render, staticRenderFns } from "./GameAboutPC.vue?vue&type=template&id=f6e06baa&scoped=true&"
import script from "./GameAboutPC.vue?vue&type=script&lang=js&"
export * from "./GameAboutPC.vue?vue&type=script&lang=js&"
import style0 from "./GameAboutPC.vue?vue&type=style&index=0&id=f6e06baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e06baa",
  null
  
)

export default component.exports